import { Vector2 } from 'three';
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass.js';
import { CONFIG } from '../config.js';

export function createBloomPipeline(renderer, scene, camera, config = CONFIG) {
  const composer = new EffectComposer(renderer);
  composer.addPass(new RenderPass(scene, camera));
  const bloom = new UnrealBloomPass(
    new Vector2(window.innerWidth, window.innerHeight),
    config.BLOOM_STRENGTH,
    config.BLOOM_RADIUS,
    config.BLOOM_THRESHOLD,
  );
  composer.addPass(bloom);

  return {
    composer,
    bloom,
    setSize(w, h) {
      composer.setSize(w, h);
    },
    setStrength(s) {
      bloom.strength = s;
    },
    render() {
      composer.render();
    },
  };
}
